(() => {const lpRoot=()=>document.getElementById('nt3-luhxe-fired');const lpDocument={querySelector:s=>{const r=lpRoot();return r?(r.matches(s)?r:r.querySelector(s)):null},querySelectorAll:s=>{const r=lpRoot();return r?r.querySelectorAll(s):[]},getElementById:id=>{const r=lpRoot();return r?r.querySelector('[id="'+CSS.escape(id)+'"]'):null},get body(){return lpRoot()}};
(() => {
  const root = lpDocument.querySelector('[data-luhxe-page]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const toggleFaq = button => {
    const item = button.closest('[data-replo-collapsible]');
    const open = button.getAttribute('aria-expanded') !== 'true';
    item.parentElement.querySelectorAll('[data-replo-collapsible]').forEach(row => {
      const trigger = row.querySelector('[aria-expanded]');
      const panel = trigger && lpDocument.getElementById(trigger.getAttribute('aria-controls'));
      const active = row === item && open;
      row.dataset.state = active ? 'open' : 'closed';
      if (trigger) trigger.setAttribute('aria-expanded', String(active));
      if (panel) { panel.hidden = !active; panel.dataset.state = row.dataset.state; }
      const icon = trigger?.querySelector('svg path');
      if (icon) icon.setAttribute('d',active ? 'M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8' : 'M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4');
    });
  };
  const play = async video => {
    if (!video) return;
    if (video.paused) { try { await video.play(); } catch { video.controls = true; } }
    else video.pause();
  };
  root.addEventListener('click', event => {
    const target = event.target.closest('[role="button"], button, summary, a');
    if (!target) return;
    if (target.closest('[data-replo-collapsible]') && target.hasAttribute('aria-expanded')) { toggleFaq(target); return; }
    const hero = target.closest('.r-11wsvw9');
    if (hero) {
      const video = hero.querySelector('video');
      if (target.matches('.r-1fxqbpx,.r-1gxczz1')) { play(video); return; }
      if (target.matches('.r-1oa7vzd')) { video.muted = !video.muted; target.setAttribute('aria-label',video.muted ? 'Unmute' : 'Mute'); return; }
      if (target.matches('.r-x7fae0')) { video.requestFullscreen?.(); return; }
    }
    if (target.id === 'cart-icon-bubble') { event.preventDefault(); window.location.href = '/cart'; }
    if (target.closest('header-drawer') && target.matches('summary')) {
      const details = target.closest('details');
      requestAnimationFrame(() => { details?.classList.toggle('menu-opening',details.open); target.setAttribute('aria-expanded',String(details.open)); });
    }
    if (target.matches('.menu-drawer__close-button')) {
      const details = root.querySelector('header-drawer details');
      if (details) { details.open=false; details.classList.remove('menu-opening'); details.querySelector('summary')?.setAttribute('aria-expanded','false'); }
    }
    if (target.matches('.localization-form__select')) {
      const wrapper=target.closest('.disclosure'); const list=wrapper?.querySelector('.disclosure__list-wrapper');
      if (list) { const open=target.getAttribute('aria-expanded')!=='true'; target.setAttribute('aria-expanded',String(open)); list.hidden=!open; }
    }
  });
  root.addEventListener('keydown',event=>{
    if (!['Enter',' '].includes(event.key) || event.target.getAttribute('role')!=='button') return;
    event.preventDefault(); event.target.click();
  });
  const setup = () => {
    root.querySelectorAll('.r-11wsvw9').forEach(box=>{
      const video=box.querySelector('video'); if (!video || video.dataset.bound) return;
      video.dataset.bound='true'; video.muted=false;
      [['.r-1gxczz1','Play'],['.r-1fxqbpx','Play'],['.r-1oa7vzd','Mute'],['.r-x7fae0','Full screen']].forEach(([selector,label])=>box.querySelector(selector)?.setAttribute('aria-label',label));
      const update=()=>{const button=box.querySelector('.r-1fxqbpx'); button?.setAttribute('aria-label',video.paused?'Play':'Pause'); const overlay=box.querySelector('.r-1gxczz1'); if(overlay)overlay.style.visibility=video.paused?'visible':'hidden';};
      video.addEventListener('play',update);video.addEventListener('pause',update);
    });
    root.querySelectorAll('[data-loop-video]').forEach(video=>{video.muted=true;video.loop=true;video.controls=true;});
  };
  setup(); document.addEventListener('shopify:section:load',setup);
})();

})();